<!-- eslint-disable max-len -->

<template>
  <a-card>
    <a-row type="flex" align="middle" justify="space-between" :gutter="10">
      <a-col class="col-center space-between"
        ><span class="title">Facebook Page</span>
        <a-input-search v-model:value="search.q" class="search-input ml-24" placeholder="Search"
      /></a-col>
      <a-col class="col-center space-between">
        <div><span>Type:</span></div>
        <a-select
          v-model:value="search.type"
          :getPopupContainer="(trigger) => trigger.parentNode"
          class="source-select"
          default-value=""
        >
          <a-select-option value=""> All Types </a-select-option>
          <a-select-option value="All messages"> All messages </a-select-option>
          <a-select-option value="Matched keyword"> Matched keyword </a-select-option>
        </a-select>
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="24">
        <!-- Table will be here -->
        <TableSetting
          :rowKey="'_id'"
          :isRowSelection="true"
          :isActionDropDown="true"
          :isTotalActive="true"
          :isTimeFromNow="true"
          :tableData="filteredSourceList"
          :columns_props="columnConfig"
          :actions="actions"
          :pagination="{
            showQuickJumper: false,
            showSizeChanger: true,
            total: filteredSourceList.length,
            showTotal: () => '',
          }"
          @toggleAction="onToggleAction"
        />
      </a-col>
    </a-row>
    <EditFacebookPage
      :visible="editPageVisible"
      :page-info="pageInfo"
      @close="resetEditData"
      @success="resetEditData"
    ></EditFacebookPage>

    <ConfirmDelete :visible="confirmVisible" @close="confirmVisible = false" @confirm="deleteFanpage">
      Are you sure delete this fanpage?
    </ConfirmDelete>
    <ConfirmDelete :visible="confirmMultipleVisible" @close="confirmMultipleVisible = false" @confirm="deleteMultiple">
      Are you sure delete multiple fanpages?
    </ConfirmDelete>
  </a-card>
</template>

<script>
import { ref, computed, onMounted, reactive } from 'vue';
import EditFacebookPage from './EditFacebookPage.vue';
import ConfirmDelete from '@/components/ConfirmDelete.vue';
import api from '@/services/api';
import { useStore } from 'vuex';
import TableSetting from '@/components/Table/TableSetting.vue';
import { notification } from 'ant-design-vue';
import helper from '@/services/helper';
export default {
  components: { EditFacebookPage, ConfirmDelete, TableSetting },
  setup() {
    const store = useStore();
    const fanpages = computed(() => store.getters['sourceSetting/fanpages']);
    const confirmVisible = ref(false);
    const confirmMultipleVisible = ref(false);
    const editPageVisible = ref(false);
    const pageInfo = ref({});
    const search = reactive({
      q: '',
      type: '',
    });
    const columnConfig = [
      {
        title: 'Page name',
        dataIndex: 'fanpageName',
        key: 'fanpageName',
        slots: { customRender: 'source_name' },
        sorter: helper.getTableSortFn('string', 'fanpageName'),
      },
      {
        title: 'Data Collection',
        dataIndex: 'type',
        key: 'type',
        slots: { customRender: 'type' },
        sorter: helper.getTableSortFn('string', 'type'),
      },
      {
        title: 'Date Added',
        dataIndex: 'updatedAt',
        key: 'updatedAt',
        slots: { customRender: 'updated_at' },
        sorter: helper.getTableSortFn('date-x', 'updatedAt'),
        defaultSortOrder: 'descend',
      },
      {
        title: 'Actions',
        key: 'action',
        slots: { customRender: 'action' },
      },
    ];

    const actions = [
      { name: 'Open Link', value: 'open_link', icon: 'external-link' },
      { name: 'Edit', value: 'edit', icon: 'edit' },
      { name: 'Delete', value: 'delete', icon: 'trash-2' },
    ];

    const selectedData = ref(null);

    const loadData = async () => {
      await store.dispatch('sourceSetting/getFanpages');
    };

    const resetEditData = () => {
      editPageVisible.value = false;
      loadData();
    };

    const onEditPage = async (data) => {
      console.log(data);
      pageInfo.value = data;
      editPageVisible.value = true;
    };

    const confirmDeleteFanpage = (data) => {
      confirmVisible.value = true;
      selectedData.value = data;
      console.log('confirm delete fanpage...');
    };

    const deleteFanpage = async () => {
      let result = await api.deleteAccountFanpage(store.state.account.brand, selectedData.value.id).catch(() => {});
      if (result && result.code === 200) {
        notification.success({
          message: 'Success',
          description: `Page ${selectedData.value.name} removed.`,
        });
      } else {
        notification.error({
          message: 'Error',
          description: `Page ${selectedData.value.name} remove failed.`,
        });
      }
      console.log('deleted fanpage...');
      confirmVisible.value = false;
      selectedData.value = null;
      loadData();
    };

    const confirmDeleteMultiple = (data) => {
      console.log([...data]);

      confirmMultipleVisible.value = true;
      selectedData.value = [...data];
      console.log('confirm delete multiple fanpages ...');
    };

    const deleteMultiple = async () => {
      const list = selectedData.value;
      let result = await api.bulkDeleteFacebookFanpage(list).catch(() => {});
      if (result && result.code === 200) {
        notification.success({
          message: 'Success',
          description: `${list.length} pages removed.`,
        });
      } else {
        notification.error({
          message: 'Error',
          description: `${list.length} pages remove failed.`,
        });
      }
      console.log('deleted fanpage...');
      confirmMultipleVisible.value = false;
      selectedData.value = null;
      loadData();
    };

    const filteredSourceList = computed(() => {
      let items = fanpages.value || [];
      if (items.length) {
        const searchTerm = search.q.trim();
        if (searchTerm) {
          items = items.filter((v) => v.fanpageName.toLowerCase().includes(searchTerm.toLowerCase()));
        }
        if (search.type) {
          items = items.filter((v) => v.type === search.type);
        }
      }
      return items;
    });

    const onToggleAction = ({ action, record }) => {
      if (action === 'edit') {
        onEditPage(record);
      } else if (action === 'delete') {
        confirmDeleteFanpage(record);
      } else if (action === 'deleteMultiple') {
        confirmDeleteMultiple(record);
      } else if (action === 'open_link') {
        window.open(`https://www.facebook.com/${record.id}`);
      }
    };

    onMounted(() => {
      loadData();
    });
    return {
      fanpages,
      confirmVisible,
      confirmMultipleVisible,
      editPageVisible,

      pageInfo,

      search,
      loadData,
      resetEditData,

      confirmDeleteFanpage,
      deleteFanpage,
      deleteMultiple,

      filteredSourceList,
      columnConfig,
      onToggleAction,
      actions,
    };
  },
};
</script>

<style scoped lang="scss">
.title {
  font-family: DM Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: left;
  color: '#272B41';
}

.search-input {
  border-radius: 18px;
  width: 250px;
  height: 36px;
}
.ml-24 {
  margin-left: 24px;
}

.col-center {
  display: flex;
  align-items: center;
  padding: 5px;
}
.source-select {
  width: 160px;
  margin-left: 8px;
  display: flex;
  align-items: center;
}

@media only screen and (max-width: 540px) {
  .space-between {
    justify-content: space-between;
    flex: auto;
  }
}
.fanpage-name {
  font-family: DM Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0em;
  text-align: left;
  margin-bottom: 9px;
}

.fanpage-id {
  font-family: DM Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
}
</style>
